import React from 'react'

const Sqaure = (props) => {
  return (
    <div className='sqaures'  onClick={props.onClick}>
    
      <p>{props.value}</p>
    </div>
  )
}

export default Sqaure
